import { Component, OnDestroy, OnInit } from '@angular/core'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { ActivatedRoute, Router } from '@angular/router'
import { LoaderService } from '../../services/loader-service/loader.service'
import { EVENT_NAMES } from '../../utils/events'
import { DEBIT_CARD_PRICE } from '../../utils/const-utils'

@Component({
  selector: 'app-debit-card-layout',
  templateUrl: './debit-card-layout.component.html',
  styleUrls: ['./debit-card-layout.component.scss'],
})
export class DebitCardLayoutComponent implements OnInit, OnDestroy {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {}

  private handleOnBack = () => {
    this.router.navigate(['..', 'firc', '4'], { relativeTo: this.route, replaceUrl: true })
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loaderService.updateLoader(false)
    }, 500)

    this.storage.set(EVENT_NAMES.cardPrince, DEBIT_CARD_PRICE)

    window.addEventListener(EVENT_NAMES.debitCardOnBackStep, this.handleOnBack)
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.debitCardOnBackStep, this.handleOnBack)
  }
}
